/// <reference path="../../trp/services/globalisation.service.ts"/>
'use strict';

namespace ekh {

    type Tenant = TR.ITenant;
    type Region = TR.IRegion;
    type PointOfSale = TR.IPointOfSale;
    type IGlobalisationService = TR.IGlobalisationService;
    type ITenant = TR.ITenant;
    type IQService = angular.IQService;
    type IPointOfSale = TR.IPointOfSale;
    type Language = TR.ILanguage;
    type IRegion = TR.IRegion;
    type ILanguage = TR.ILanguage;
    type IRegionalContext = TR.IRegionalContext;
    type IDomain = TR.IDomain;


    export interface ICountryPickerService {
        getDomain():Promise<IDomain>;
        selectRegionalContext(regionalContext:IRegionalContext):Promise<IRegionalContext>;
    }

    export class CountryPickerService implements ICountryPickerService {
        getDomainInfo:Promise<IDomain> | null;

        constructor(private globalisationService:IGlobalisationService) {
        }

        getDomain():Promise<IDomain> {
            if (this.getDomainInfo) {
                return this.getDomainInfo;
            }

            this.getDomainInfo = this.globalisationService.getSelectedRegionalContext()
                .then((regionalContext:IRegionalContext) =>
                    this.globalisationService.getRegions(regionalContext.TenantId, regionalContext.ParentDomainId)
                        .then((regions:IRegion[]) => {
                            return {
                                Context: regionalContext,
                                Regions: regions
                            };
                        }));

            return this.getDomainInfo;
        };

        selectRegionalContext(regionalContext:IRegionalContext):Promise<IRegionalContext> {
            return this.globalisationService.setRegionalContext({
                ParentDomainId: regionalContext.ParentDomainId,
                PointOfSaleId: regionalContext.PointOfSale.Id,
                CountryCode: regionalContext.PointOfSale.CountryCode,
                CultureCode: regionalContext.Language ? regionalContext.Language.Code : ''
            }).then(resp => this.globalisationService.getSelectedRegionalContext());
        };
    }

    angular
        .module('ekh')
        .service('countryPickerService', CountryPickerService);
}
